import { useParams, Link } from 'react-router-dom';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

const categoryArticleImages: Record<string, string> = {
  'xinshou-ru-men-gonglue': 'https://readdy.ai/api/search-image?query=Anime%20style%20new%20adventurer%20starting%20journey%20in%20fantasy%20village%2C%20cute%20characters%2C%20soft%20pastel%20colors%2C%20warm%20lighting%2C%20beginner%20guide%20theme&width=800&height=450&seq=cat-xinshou&orientation=landscape',
  'shenmi-daoju-zhong-sheng-zhi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20mystical%20rebirth%20circle%20with%20glowing%20magic%20symbols%2C%20ethereal%20light%2C%20fantasy%20atmosphere%2C%20soft%20pink%20and%20mint&width=800&height=450&seq=cat-zhongsheng&orientation=landscape',
  'renqi-juese-xiaoying-xiangjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20healer%20girl%20with%20cherry%20blossoms%2C%20gentle%20expression%2C%20magical%20healing%20light%2C%20soft%20pastel%20background&width=800&height=450&seq=cat-xiaoying&orientation=landscape',
  'xinghu-yiji-tanxian-riji': 'https://readdy.ai/api/search-image?query=Anime%20style%20ancient%20ruins%20with%20starry%20reflection%20on%20lake%2C%20adventure%20party%2C%20mysterious%20atmosphere%2C%20soft%20lighting&width=800&height=450&seq=cat-xinghu&orientation=landscape',
  'qihuan-shijie-sheding-quanjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20world%20with%20floating%20islands%20and%20constellations%2C%20ancient%20magic%20books%2C%20mystical%20elements%2C%20soft%20pastel&width=800&height=450&seq=cat-shijieguan&orientation=landscape',
  'gaojie-zhandou-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20battle%20with%20cute%20characters%20and%20magic%20effects%2C%20dynamic%20action%2C%20soft%20colors&width=800&height=450&seq=cat-zhandou&orientation=landscape',
  'an-ying-senlin-mi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20dark%20mysterious%20forest%20with%20soft%20glowing%20lights%2C%20ethereal%20atmosphere%2C%20fantasy%20scene%2C%20muted%20pastel%20colors&width=800&height=450&seq=cat-anying&orientation=landscape',
  'quan-juese-shou-cang-zhi-nan': 'https://readdy.ai/api/search-image?query=Anime%20style%20group%20of%20cute%20chibi%20characters%20posing%20together%2C%20diverse%20designs%2C%20cheerful%20atmosphere%2C%20soft%20pastel%20palette&width=800&height=450&seq=cat-jiaose&orientation=landscape',
  'jingyan-jiasu-shengji-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20leveling%20up%20with%20glowing%20aura%2C%20fantasy%20training%20scene%2C%20soft%20lighting%2C%20determined%20expression&width=800&height=450&seq=cat-shengji&orientation=landscape',
  'huoban-qianghua-jiban-zhinan': 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20characters%20bonding%20moment%2C%20heartwarming%20friendship%20scene%2C%20sparkling%20magic%20connection%2C%20soft%20pastel&width=800&height=450&seq=cat-jiban&orientation=landscape',
  'daoju-cangku-guanli-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20organized%20magical%20inventory%20with%20potions%20and%20scrolls%2C%20cozy%20fantasy%20storage%2C%20soft%20lighting&width=800&height=450&seq=cat-cangku&orientation=landscape',
  'weilai-gengxin-yugao': 'https://readdy.ai/api/search-image?query=Anime%20style%20sky%20castle%20floating%20in%20clouds%2C%20new%20adventure%20horizon%2C%20hopeful%20atmosphere%2C%20soft%20pastel%20colors&width=800&height=450&seq=cat-gengxin&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!currentCategory) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <h1 className="text-2xl font-heading text-foreground-900 mb-4">分类未找到</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700">返回首页</Link>
        </div>
      </div>
    );
  }

  const catSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `重生萝莉岛 - ${currentCategory.name}`,
    description: currentCategory.description,
    url: `https://chongshengluolidao.com/category/${currentCategory.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '重生萝莉岛',
      url: 'https://chongshengluolidao.com',
    },
    inLanguage: 'zh-CN',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://chongshengluolidao.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: currentCategory.name,
        item: `https://chongshengluolidao.com/category/${currentCategory.slug}`,
      },
    ],
  };

  return (
    <>
      <SEO
        title={`重生萝莉岛${currentCategory.name} | 萌系重生奇幻岛屿`}
        description={currentCategory.description}
        keywords={`重生萝莉岛,${currentCategory.name},萝莉岛冒险,重生奇幻岛屿,萌系重生故事`}
        canonicalUrl={`https://chongshengluolidao.com/category/${currentCategory.slug}`}
        jsonLd={[catSchema, breadcrumbSchema]}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: currentCategory.name },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-8 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
                {currentCategory.name}
              </h1>
              <p className="text-foreground-600 max-w-xl mx-auto">{currentCategory.description}</p>
            </div>

            <div className="flex items-center justify-center gap-2 flex-wrap mb-10">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-50 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={categoryArticleImages[article.slug] || categoryArticleImages['xinshou-ru-men-gonglue']}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <h2 className="font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-500">
                        <span>{article.date}</span>
                        <span>{article.readTime}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-600">该分类暂无文章，敬请期待！</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}